import { ILog } from "@/types/logs.type";
import { IVehicleLog } from "../../types/vehicleLog";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const makeRequestDebounced = createDebounce(makeRequest, 200);
const API_URL = `${import.meta.env.VITE_API_URL}/logs`;

export async function vehicleLogsFindByLincesePlate(
  licensePlate: string | undefined
): Promise<ApiResponseType<IVehicleLog[]>> {
  const url = `${import.meta.env.VITE_API_URL}/audits/vehicle/${licensePlate}`;

  return (await makeRequestDebounced(url)) as ApiResponseType<IVehicleLog[]>;
}

export const getLogsByEntity = async (
  {
    entity,
    entityId,
    page = 1,
    itemsPerPage = 10,
    orderBy = "-timestamp",
  } = {} as {
    entity: string;
    entityId: string;
    page?: number;
    itemsPerPage?: number;
    orderBy?: string;
  }
) => {
  if (!entity || !entityId) {
    return Promise.resolve({
      ok: false,
      message: "Entity e EntityId são obrigatórios.",
    } as ApiResponseType<ILog[]>);
  }
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
  });
  orderBy && params.append("orderBy", orderBy);

  const url = `${API_URL}/?${params.toString()}`;
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      entity,
      entityid: entityId,
    },
  };
  const result = (await makeRequestDebounced(url, options)) as Promise<
    ApiResponseType<ILog[]>
  >;
  return result;
};
